import React, { useState } from 'react';
import { Edit, SimpleForm, TextInput, useNotify, useRefresh, Confirm } from 'react-admin';
import { axios as httpClient } from '../api';

const TurbineType = ({ record }) => {
  return <span>Turbine type {record ? `"${record.name}"` : ''}</span>;
};

const readFileAsBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
});

// Deliberately NOT part of the SimpleForm's normal Save flow (see Create.js
// for the initial-upload path) - replacing an existing type's schema
// affects every turbine already deployed with it, so it gets its own
// confirmation and its own error surfacing instead of hiding behind a
// routine rename Save.
const ReplaceSchema = ({ record }) => {
  const [file, setFile] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();

  if (!record) return null;

  const handleReplace = async () => {
    setConfirmOpen(false);
    if (!file) return;
    setLoading(true);
    try {
      const excelBase64 = await readFileAsBase64(file);
      await httpClient.post(`/turbineTypes/${record.id}/schema`, { excelBase64 });
      notify('Schema replaced successfully');
      setFile(null);
      refresh();
    } catch (err) {
      notify((err.response && err.response.data && err.response.data.error) || err.message, { type: 'warning' });
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    try {
      const response = await httpClient.get(`/turbineSchemas/${record.schemaId}/xlsx`, { responseType: 'blob' });
      const url = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${record.schemaId}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      notify('No Excel file stored for this schema yet', { type: 'warning' });
    }
  };

  return (
    <div style={{ marginTop: '2rem', padding: '1rem', border: '1px solid #ddd', maxWidth: '32rem' }}>
      <h3>Schema (Excel)</h3>
      <p>Re-uploading replaces the live register/state/failure map for every turbine of this type.</p>
      <input type="file" accept=".xlsx" onChange={(e) => setFile(e.target.files[0] || null)} />
      <div style={{ marginTop: '1rem' }}>
        <button
          type="button"
          disabled={!file || loading}
          onClick={() => setConfirmOpen(true)}
        >
          Replace Schema
        </button>
        {record.schemaId && (
          <button type="button" onClick={handleDownload} style={{ marginLeft: '1rem' }}>
            Download current Excel
          </button>
        )}
      </div>
      <Confirm
        isOpen={confirmOpen}
        title="Replace schema?"
        content="This replaces the live register map for every turbine of this type - continue?"
        onConfirm={handleReplace}
        onClose={() => setConfirmOpen(false)}
      />
    </div>
  );
};

export default (props) => (
  <Edit title={<TurbineType />} {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <ReplaceSchema />
    </SimpleForm>
  </Edit>
);
